import type { ReactNode } from 'react';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

const LABEL_CLASS =
  'pointer-events-none absolute top-1/2 left-2 block max-w-[calc(100%-3rem)] origin-left -translate-y-1/2 truncate bg-card px-1 text-sm font-normal text-muted-foreground transition-[top,scale,color] duration-200 ease-out group-data-filled/filter-field:max-w-[calc(100%-1rem)] group-focus-within/filter-field:max-w-[calc(100%-1rem)]';
const FLOATED_LABEL_CLASS =
  'group-data-filled/filter-field:top-0 group-data-filled/filter-field:scale-80 group-focus-within/filter-field:top-0 group-focus-within/filter-field:scale-80 group-has-[[aria-expanded=true]]/filter-field:top-0 group-has-[[aria-expanded=true]]/filter-field:scale-80';
const ACTIVE_LABEL_CLASS =
  'group-data-filled/filter-field:font-medium group-data-filled/filter-field:text-primary group-focus-within/filter-field:text-primary group-has-[[aria-expanded=true]]/filter-field:text-primary';

interface FloatingFieldLabelProps {
  children: ReactNode;
  htmlFor?: string | undefined;
  isRequired?: boolean | undefined;
}

export function FloatingFieldLabel({
  children,
  htmlFor,
  isRequired = false,
}: FloatingFieldLabelProps) {
  return (
    <Label htmlFor={htmlFor} className={cn(LABEL_CLASS, FLOATED_LABEL_CLASS, ACTIVE_LABEL_CLASS)}>
      {children}
      {isRequired ? <span className="ml-0.5 text-destructive">*</span> : null}
    </Label>
  );
}
